import { css } from "@emotion/css";
import { theme } from "../../utils/theme";

export const CHAT_HISTORY_DIALOG_BAR_HEIGHT = 48;

export const chatHistoryBarCSS = css`
  height: ${CHAT_HISTORY_DIALOG_BAR_HEIGHT}px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0;
  margin-left: -6px;
  z-index: 12;

  &.in-dialog {
    padding: 0 16px;
    margin-left: 0;
    background: ${theme.palette.gray[10]};
  }
`;

export const chatHistoryBarIconCSS = css`
  .in-dialog & {
    width: 3rem !important;
    height: 3rem !important;
    padding: 0 !important;
  }
`;

export const chatHistoryBarFloatingCSS = css`
  height: auto;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.15);
  padding: 0.75rem 1.5rem 0.75rem 0.75rem;
  gap: 1rem;
  border-radius: 1rem;
  margin-top: 0.75rem;
  margin-left: 0.75rem;
`;
